module.exports = __webpack_public_path__ + "static/img/empty.397879c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-table2/static/images/empty.svg
// module id = w00m
// module chunks = 7